import React from 'react';
import { Navigate, NavigateProps, useLocation } from 'react-router-dom';

type Props = NavigateProps;

const NavigateWithParams: React.FC<Props> = ({ to, ...props }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const toWithParams = `${to}?${searchParams.toString()}`;

  return <Navigate to={toWithParams} {...props} />;
};

export default NavigateWithParams;
